module.exports = __webpack_public_path__ + "img/congratulations.c81a3d4b.svg";